export default __webpack_public_path__ + "static/media/FZ152.5a1a845e.pdf";